export default "__VITE_ASSET__DJVg4Imf__"